export const GAME_ID = 'gameId';
export const GROUP_ID = 'groupId';
export const GROUP_NAME = 'groupName';
export const SECURITY_TOKEN = 'securityToken';
export const TASK_GROUP_ID = 'taskGroupId';
export const RESULT_GAME_ID = 'resultGameId';
export const RESULT_GROUP_ID = 'resultGroupId';


// WEBPACK FOOTER //
// ./src/Logic/storageKeys.js